import createBrowserHistory from 'history/createBrowserHistory';
import ModalConfirmation from './ModalConfirmation';

let history;

function createHistory(getUserConfirmation) {
  return createBrowserHistory({
    getUserConfirmation
  });
}

export function getHistory() {
  if (!history) {
    const getModalConfirmation = ModalConfirmation('modal-holder');
    history = createHistory(getModalConfirmation);
  }
  return history;
}